import {ReactComponent as FlashIconSvg} from "../assets/img/flash-svgrepo-com.svg";

const FlashIcon = () => {
    return <div className="single-use">
        <FlashIconSvg/>
    </div>
};

export default FlashIcon;